import { motion } from 'framer-motion';

export default function FancyHeading({ children, ...props }) {
  return (
    <motion.header className="relative" {...props}>
      <div className="absolute inset-0 grid place-items-center">
        <div className="h-1 w-full max-w-xl rounded-full bg-primary-500"></div>
      </div>
      <div className="grid place-items-center">
        <div className="relative bg-white px-8">
          <h2 className="text-center text-3xl font-medium lg:text-4xl">{children}</h2>
        </div>
      </div>
    </motion.header>
  );
}
